import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../environments/environment";

const reportUrl = `${environment.apiUrl}/Report`;
@Injectable({
  providedIn: 'root'
})
export class ReportsService {

  constructor(private http: HttpClient) { }

  getDropdownForReport(): Observable<any[]> {
    return this.http.get<any[]>(`${reportUrl}/GetAdminReports`);
  }

  getReport(reportId: string, startDate: string, endDate: string): Observable<any[]> {
    return this.http.get<any[]>(
      `${reportUrl}/GetAdminReportData?reportId=${reportId}&startDate=${startDate}&endDate=${endDate}&v=${(new Date()).getTime()}`
    );
  }

  GetReminderMessageStatusReport(id: number, startDate: string, endDate: string): Observable<any[]> {
    return this.http.get<any[]>(
      `${reportUrl}/GetReminderMessageStatusReport?companyId=${id}&startDate=${startDate}&endDate=${endDate}&v=${(new Date()).getTime()}`
    );
  }
  
  getStorageReport(): Observable<any[]> {
    return this.http.get<any[]>(
      `${reportUrl}/GetCompanyStorageReport`
    );
  }
  exportReminderMessageStatusData(data: any, startDate: string, endDate: string) {
    return this.http.get<any[]>(`${environment.apiUrl}/Report/getReminderMessageStatusData?companyIds=${data}&startDate=${startDate}&endDate=${endDate}`);
  }
}
